import React from "react";
import styles from "./TermsOfService.module.css";

const TermsOfService = () => (
  <div className={styles.termsContainer}>
    <h1>Terms of Service</h1>
    <p>Last updated: January 30, 2026</p>

    <section className={styles.section}>
      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using Aurelia Apartments’ website or services, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any part of these terms, you must not use our services.
      </p>
    </section>

    <section className={styles.section}>
      <h2>2. Services Provided</h2>
      <p>
        Aurelia Apartments provides accommodation booking and related hospitality services. We reserve the right to modify, suspend, or discontinue any part of our services at any time without notice.
      </p>
    </section>

    <section className={styles.section}>
      <h2>3. User Responsibilities</h2>
      <ul>
        <li>Provide accurate and complete information when making reservations or creating an account.</li>
        <li>Comply with all applicable laws and regulations.</li>
        <li>Respect our property, staff, and other guests during your stay.</li>
      </ul>
    </section>

    <section className={styles.section}>
      <h2>4. Booking, Payment, and Cancellation</h2>
      <ul>
        <li>All bookings are subject to availability and confirmation.</li>
        <li>Payment terms and accepted methods are specified during the booking process.</li>
        <li>Cancellation and refund policies are provided at the time of booking and may vary by rate or offer.</li>
      </ul>
    </section>

    <section className={styles.section}>
      <h2>5. Privacy and Data Protection</h2>
      <p>
        Your privacy is important to us. Please review our <a href="/privacy-policy">Privacy Policy</a> to understand how we collect, use, and protect your personal information in accordance with the Nigeria Data Protection Regulation (NDPR).
      </p>
    </section>

    <section className={styles.section}>
      <h2>6. Intellectual Property</h2>
      <p>
        All content, trademarks, and materials on this website are the property of Aurelia Apartments or its licensors. You may not use, reproduce, or distribute any content without our prior written consent.
      </p>
    </section>

    <section className={styles.section}>
      <h2>7. Limitation of Liability</h2>
      <p>
        Aurelia Apartments is not liable for any indirect, incidental, or consequential damages arising from your use of our services. Our total liability is limited to the amount paid by you for the specific service in question.
      </p>
    </section>

    <section className={styles.section}>
      <h2>8. Changes to Terms</h2>
      <p>
        We may update these Terms of Service from time to time. Continued use of our services after changes constitutes acceptance of the new terms.
      </p>
    </section>

    <section className={styles.section}>
      <h2>9. Governing Law</h2>
      <p>
        These Terms are governed by the laws of the Federal Republic of Nigeria. Any disputes shall be resolved in the courts of Nigeria.
      </p>
    </section>

    <section className={styles.section}>
      <h2>10. Contact Us</h2>
      <p>
        For questions about these Terms, please contact us at <a href="mailto:info@aurelia-apartments.com">info@aurelia-apartments.com</a>.
      </p>
    </section>
  </div>
);

export default TermsOfService;
